import { type Dispatch, type RefObject, type SetStateAction, useEffect } from 'react';

/*
If the GroupTitle labels have long names, this adjusts the bets wrapper to match the labels wrapper
to maintain label/bet alignment.
*/

export const useAlignBetsWithLabels = ({
  labelsRef,
  setBetsWrapperWidth,
}: {
  labelsRef: RefObject<HTMLDivElement | null>;
  setBetsWrapperWidth: Dispatch<SetStateAction<number>>;
}) => {
  const defaultBetsWrapperWidth = 203;

  useEffect(() => {
    const labelsWidth = labelsRef.current?.offsetWidth;
    const shouldSetWidth = labelsWidth && labelsWidth > defaultBetsWrapperWidth;

    if (shouldSetWidth) {
      setBetsWrapperWidth(labelsWidth);
    }
  }, [defaultBetsWrapperWidth, labelsRef, setBetsWrapperWidth]);
};
